// upgrade-property.ts — Web-Component „lazy/upgraded properties".
//
// Wird eine Property (z.B. el.options / el.value / el.checked) gesetzt, BEVOR
// das Custom Element ge-upgradet ist bzw. bevor render() den Accessor via
// Object.defineProperty installiert, landet sie als eigene Daten-Property auf
// der Instanz. Ein spaeteres defineProperty mit demselben Key wuerde diesen Wert
// verwerfen. takeOwnProperty holt den vorab gesetzten Wert heraus (und entfernt
// die Daten-Property), damit render() ihn nach dem Definieren des Accessors
// erneut durch den Setter schleusen kann.
export function takeOwnProperty<T = unknown>(host: HTMLElement, prop: string): T | undefined {
  if (Object.prototype.hasOwnProperty.call(host, prop)) {
    const v = Reflect.get(host, prop) as T;
    Reflect.deleteProperty(host, prop);
    return v;
  }
  return undefined;
}
